// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-rating-rating-2-rating-beawh{height:20px;width:100px;display:flex}.components-rating-rating-2-ratingWrapper-ebtjm{align-items:center;display:flex;grid-gap:4px;gap:4px}.components-rating-rating-2-ratingCount-qdzah{font-size:12px}.components-rating-rating-2-item-bgegn,.components-rating-rating-2-ratingCount-qdzah{color:var(--color-gray)}.components-rating-rating-2-item-bgegn{height:20px;width:20px}.components-rating-rating-2-item-bgegn.components-rating-rating-2-active-hvwmh{color:var(--color-orange)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rating": "components-rating-rating-2-rating-beawh",
	"ratingWrapper": "components-rating-rating-2-ratingWrapper-ebtjm",
	"ratingCount": "components-rating-rating-2-ratingCount-qdzah",
	"item": "components-rating-rating-2-item-bgegn",
	"active": "components-rating-rating-2-active-hvwmh"
};
module.exports = ___CSS_LOADER_EXPORT___;
